import React, { ReactElement } from 'react';
import { Lock, Sparkles } from 'lucide-react';
import { HashLink } from 'react-router-hash-link';

function TopBar(): ReactElement {
  return (
    <>
      {/* Top Bar */}
      <header className="sticky top-0 z-40 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-slate-200/60">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center gap-2">
              <img alt="logo" src="/logo.svg" height={36} width={36} />
              <a href="/">
                <span className="font-semibold tracking-tight">FlatJSON</span>
              </a>
            </div>
            <nav className="hidden md:flex items-center gap-8 text-sm">
              <HashLink to="/#features" className="hover:text-slate-900">
                Features
              </HashLink>
              <HashLink to="/#how" className="hover:text-slate-900">
                How it works
              </HashLink>
              <HashLink to="/#playground" className="hover:text-slate-900">
                Try it free
              </HashLink>
              <HashLink to="/#pricing" className="hover:text-slate-900">
                Pricing
              </HashLink>
            </nav>
            <div className="flex items-center gap-3">
              <a
                className="hs-button inline-flex items-center gap-2 rounded-xl border border-orange-200 px-3 py-2 text-sm font-medium hover:bg-orange-50"
                href="#pricing">
                <Lock className="h-4 w-4" /> API Access
              </a>
              <a
                className="hs-button inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-orange-500 to-amber-400 px-3 py-2 text-sm font-semibold text-white shadow hover:brightness-95"
                href="#playground">
                <Sparkles className="h-4 w-4" /> Try Free
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default TopBar;
